import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { ORDER_CACHE_KEYS } from "./keys";

import { OrderRepository } from "@/repositories/order";
import { OrderFilters } from "@/types";

export const useGetAllOrders = (filters: OrderFilters) => {
  const orderRepository = useRef(new OrderRepository());

  return useQuery({
    queryKey: ORDER_CACHE_KEYS.LIST(filters),
    queryFn: async () => {
      return await orderRepository.current.findAll(filters);
    },
    placeholderData: keepPreviousData,
  });
};
